// extracted by mini-css-extract-plugin
module.exports = {"inspect":"inspect___91yF-","wrapper":"wrapper___3CA4p","form":"form___1rL9-","form__control":"form__control___DKCq7","form__label":"form__label___1DqYo"};